export default [
  {
    path: '/main/os-sw',
    meta: {
      tag: 'list_os_sw',
      name: 'Ordens de serviço - Software',
      breadcrumb: 'Ordens de serviço - Software'
    },
    component: () => import(/* webpackChunkName: "os-software-list" */ '@/views/main/os-sw/Index.vue'),
    children: [
      {
        path: '',
        name: 'listossw',
        meta: {
          tag: 'list_os_sw',
          name: 'Ordens de serviço - Software',
          menu: 'os-sw'
        },
        component: () => import(/* webpackChunkName: "os-software-list" */ '@/views/main/os-sw/List.vue')
      },
      {
        path: 'add',
        name: 'addossw',
        meta: {
          tag: 'add_os_sw',
          name: 'Adicionar | Ordem de serviço - Software',
          breadcrumb: 'Adicionar Ordem de serviço - Software',
          menu: 'os-sw'
        },
        component: () => import(/* webpackChunkName: "os-software-add" */ '@/views/main/os-sw/Add.vue')
      }
    ]
  }
]
